// import PropTypes from 'prop-types'
import { Link as GatsbyLink } from 'gatsby'
import React from 'react'

const Link = ({ children, to, ...props }) => {
  const internal = /^\/(?!\/)/.test(to)
  // Todo Handle anchor links
  // const anchor = /#\w*/.test(to)

  if (internal) {
    return (
      <GatsbyLink to={to} {...props}>
        {children}
      </GatsbyLink>
    )
  }

  return (
    <a href={to} {...props} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  )
}

Link.propTypes = {}

export default Link
